import { render } from "./LawyersWeRecommend.vue?vue&type=template&id=37f00500&scoped=true"
import script from "./LawyersWeRecommend.vue?vue&type=script&lang=js"
export * from "./LawyersWeRecommend.vue?vue&type=script&lang=js"

import "./LawyersWeRecommend.vue?vue&type=style&index=0&id=37f00500&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f00500"]])

export default __exports__